import { useState } from 'react'
import { useGiftGivers } from '../../../context/GiftGiversProvider'

export const useRevealSurprise = (
  giftGiverId: string
): [boolean, () => void] => {
  const { revealSurprises } = useGiftGivers()
  const [isRevealedSurprise, setIsRevealedSurprise] = useState<boolean>(false)

  const revealSurprisesAndUpdateState = () => {
    revealSurprises(giftGiverId)
    setIsRevealedSurprise(true)
  }

  return [isRevealedSurprise, revealSurprisesAndUpdateState]
}

export default useRevealSurprise
